export default __webpack_public_path__ + "static/2-9adf343f5197e438c0ae5e9bf44f138c.png";